import React from 'react';
import styled from 'styled-components';

import { SizeToRem } from '../../../lib/style/ThemeStyle';

export const Padding = ({
  top = 0,
  bottom = 0,
  left = 0,
  right = 0,
  children,
}) => (
  <PaddingStyle top={top} bottom={bottom} left={left} right={right}>
    {children}
  </PaddingStyle>
);

const PaddingStyle = styled.div`
  padding-top: ${(props) => SizeToRem(props.top)};
  padding-bottom: ${(props) => SizeToRem(props.bottom)};
  padding-left: ${(props) => SizeToRem(props.left)};
  padding-right: ${(props) => SizeToRem(props.right)};
`;

export const VerticalPadding = ({ padding = 0, children }) => (
  <Padding top={padding} bottom={padding}>
    {children}
  </Padding>
);

export const HorizontalPadding = ({ padding = 0, children }) => (
  <Padding left={padding} right={padding}>
    {children}
  </Padding>
);
